import * as React from 'react';
import styled from 'styled-components';
import CloseIcon from '@sdk/components/ui/CloseIcon';

const CloseContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

type Props = { onClose: () => void };

const SurveyCloseButton: React.FC<React.PropsWithChildren<Props>> = ({ onClose }) => {
  return (
    <CloseContainer>
      <CloseIcon onClick={onClose} spacing={10} />
    </CloseContainer>
  );
};

export default SurveyCloseButton;
